import create from 'zustand'
import { getLang } from './functions'

export const useLangStore = create((set) => ({
  lang: getLang(),
  setLang: (newLang) => set(() => ({ lang: newLang })),
}))